var map = {
	"./ask.svg": "688a",
	"./book.svg": "cda0",
	"./bug.svg": "937c",
	"./camera-1.svg": "f57f",
	"./camera.svg": "5b31",
	"./caret-right.svg": "a69d",
	"./chart.svg": "20e7",
	"./components.svg": "7a81",
	"./control.svg": "d2f1",
	"./download.svg": "039a",
	"./editor.svg": "54cc",
	"./full-screen-exit.svg": "35a7",
	"./full-screen.svg": "6d88",
	"./gibberella.svg": "042a",
	"./home.svg": "0331",
	"./home0.svg": "24d1",
	"./humidity.svg": "271b",
	"./label.svg": "4cec",
	"./light.svg": "f606",
	"./line.svg": "a6d9",
	"./locked.svg": "d031",
	"./message.svg": "15e8",
	"./monitoring.svg": "f386",
	"./mouse.svg": "35e0",
	"./other.svg": "7b2c",
	"./page.svg": "452c",
	"./pagedetails.svg": "6394",
	"./pageform.svg": "688a4",
	"./pagelist.svg": "47fb",
	"./pause.svg": "b849",
	"./pen.svg": "5acf",
	"./person.svg": "a59d",
	"./photo.svg": "d55e",
	"./pin.svg": "f937",
	"./pm10.svg": "9e19",
	"./pm25.svg": "f470",
	"./pressure.svg": "8c1e",
	"./rain.svg": "1986",
	"./refresh.svg": "b41b",
	"./replay.svg": "08fe",
	"./s-fold.svg": "ba71",
	"./s-unfold.svg": "3728",
	"./sali.svg": "54d1",
	"./set.svg": "6274",
	"./sound-close.svg": "a7f1",
	"./sound-open.svg": "0adf",
	"./sound.svg": "cbda",
	"./spores.svg": "85c6",
	"./statics.svg": "952c",
	"./stop.svg": "f12f",
	"./sun.svg": "59b7",
	"./survey.svg": "c9ef",
	"./thermometer.svg": "6e983",
	"./traps.svg": "0aea",
	"./trash.svg": "53bd",
	"./tree.svg": "0e8f",
	"./water-drop.svg": "5791",
	"./wind.svg": "fac0",
	"./windsock.svg": "b182"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "23f1";